import { useTheme, Typography, useMediaQuery } from '@mui/material';

import { CartResponseModel } from 'src/api/models/cart';
import { DetailsFavouritesItemModel } from 'src/api/models/favourites';

import useFavouritesProductList from 'src/sections/favourites/favourite-products/use-favourite-products-list';

import FavouriteProductsListGrid from './favourite-products-list-grid';
import FavouriteProductsListTable from './favourite-products-list-table';

interface FavouritesSingleListProps {
  cart: CartResponseModel;
  items: DetailsFavouritesItemModel[];
  collectionId: string;
}

export default function FavouriteProductsList({
  cart,
  items: productItems,
  collectionId,
}: FavouritesSingleListProps) {
  const {
    handleQuantityChange,
    handleAddToCart,
    handleRemoveFromCart,
    handleUpdate,
    deleteItem,
    activeOperations,
    items,
  } = useFavouritesProductList({ cart, productItems, collectionId });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  if (productItems.length === 0) {
    return <Typography>No products found</Typography>;
  }

  if (isMobile) {
    return (
      <FavouriteProductsListGrid
        items={items}
        handleQuantityChange={handleQuantityChange}
        handleUpdate={handleUpdate}
        handleAddToCart={handleAddToCart}
        handleRemoveFromCart={handleRemoveFromCart}
        deleteItem={deleteItem}
        activeOperations={activeOperations}
      />
    );
  }

  return (
    <FavouriteProductsListTable
      items={items}
      handleQuantityChange={handleQuantityChange}
      handleUpdate={handleUpdate}
      handleAddToCart={handleAddToCart}
      handleRemoveFromCart={handleRemoveFromCart}
      deleteItem={deleteItem}
      activeOperations={activeOperations}
    />
  );
}
